import React,{useEffect} from "react"
import SurveyViewer from "../../components/SurveyViewer"
import "./Surveys.css"
import { authenticationService } from "../../services";
import { Modal, message, Tree, Button, Row, Col, Drawer, Space, Carousel, Avatar, Form, Input, Select, TimePicker, Switch ,Tabs,Checkbox} from 'antd';
import keindl_banner from '../../images/icons/keindl_banner_v2.png'
import nextbike from '../../images/icons/nextbike.png'

export const ResidentSurvey = (props) => {
    useEffect(() => {
		if(!authenticationService.getUser()) {
			authenticationService.loginAnonymous()
		}
	}, [])
return(
    <div className="bigSurveyPage">    
        <div className="bigSurveyContent">
        <SurveyViewer  visible={true} bigSurvey={true} surveyId={6} />
       
       
     {/*
        <div className="bottomSponsoredBannner">
            
            <p className="projectSupportedByText">Projekt podržao:</p>         
        </div>
        <div className="bottomSponsoredBannner">
            <a href='https://www.nextbike.hr/'> <img className="bannerElement" src={nextbike}></img></a>          
        </div>
        </div>
         <div className="leftSponzoredBannner">

        </div>
        <div className="rightSponzoredBannner">
        </div>
     */}
       <div id="bottomSurveyElement"></div>
    </div>
    </div>
    )
  
}